import React from 'react';
import Grid from '../../../components/layout/grid/Grid';
import InputWithActionButton from './InputWithActionButton';
import CustomButton from '../../../components/common/CustomButton/CustomButton';
import CustomCheckbox from '../../../components/common/CustomCheckbox';

const BankDetailsForm = ({ formik, onNext, onBack }) => {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    setTouched,
    validateForm,
  } = formik;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValue(name, value.toUpperCase());
  };

  const handleNextClick = async () => {
    await setTouched({
      bank_ifsc_code: true,
      bank_name: true,
      bank_branch: true,
      bank_account_number: true,
      terms_accepted: true,
    });

    const formErrors = await validateForm();

    if (!values.terms_accepted) {
      return;
    }

    if (formErrors && Object.keys(formErrors).length === 0) {
      const payload = {
        bank_ifsc_code: values.bank_ifsc_code,
        bank_name: values.bank_name,
        bank_branch: values.bank_branch,
        bank_account_number: values.bank_account_number,
      };
      onNext(payload);
    }
  };

  return (
    <>
      <h2 className="font-semibold text-2xl mb-6">Bank Details</h2>

      <Grid gap={24}>
        <Grid item xs={12} md={6}>
          <InputWithActionButton
            name="bank_ifsc_code"
            label="Bank IFSC Code"
            required
            placeholder="Enter IFSC code"
            value={values.bank_ifsc_code}
            onChange={handleInputChange}
            error={touched.bank_ifsc_code && errors.bank_ifsc_code}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputWithActionButton
            name="bank_name"
            label="Bank Name"
            required
            placeholder="Enter bank name"
            value={values.bank_name}
            onChange={(e) => setFieldValue('bank_name', e.target.value)}
            error={touched.bank_name && errors.bank_name}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputWithActionButton
            name="bank_branch"
            label="Bank Branch"
            required
            placeholder="Enter bank branch"
            value={values.bank_branch}
            onChange={(e) => setFieldValue('bank_branch', e.target.value)}
            error={touched.bank_branch && errors.bank_branch}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputWithActionButton
            name="bank_account_number"
            label="Account Number"
            required
            placeholder="Enter account number"
            value={values.bank_account_number}
            onChange={(e) => setFieldValue('bank_account_number', e.target.value)}
            error={touched.bank_account_number && errors.bank_account_number}
          />
        </Grid>

        <Grid item xs={12}>
          <CustomCheckbox
            name="terms_accepted"
            checked={values.terms_accepted}
            onChange={(e) => setFieldValue('terms_accepted', e.target.value)}
            label={
              <>
                I have read and agree to the{' '}
                <span className="text-primary font-medium">Terms and Conditions.</span>
              </>
            }
            required
          />
        </Grid>
      </Grid>

      <div className="flex justify-end gap-4 mt-6">
        <CustomButton
          type="reset"
          label="Reset"
          variant="default"
          onClick={() => formik.resetForm()}
        />
        <CustomButton
          type="button"
          label="Back"
          variant="default"
          onClick={onBack}
        />
        <CustomButton
          type="button"
          label="Submit"
          variant="primary"
          onClick={handleNextClick}
          isLoading={formik.isSubmitting}
          disabled={formik.isSubmitting || !values.terms_accepted}
        />
      </div>
    </>
  );
};

export default BankDetailsForm;
